module.exports = __webpack_public_path__ + "media/images/icons/form_venue_step_2-46e17ed36573b5f89f1484cf5392a727.svg";